import {
  tag_colorTagDefaultBackground,
  tag_colorTagDefaultText,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_sm } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const content = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
`

// Span-based pill for contexts where a block element is invalid — e.g. inside
// the dropdown trigger <button>. Mirrors the default ext-ui Pill's visual
// tokens while staying phrasing content (no <div>/<p>).
export const inlinePill = css`
  ${content};
  padding: ${spacing(0.5)} ${spacing(1)};
  border-radius: ${spacing(1.25)};
  background-color: ${tag_colorTagDefaultBackground};
  color: ${tag_colorTagDefaultText};
  ${font_sm};
  font-family: ${font_family_weight_medium};
`
